export const Days = {
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
    0: 'Sunday'
}
export const Months:string[] = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];